import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DistributionListCheckboxComponent } from "../distribution-list-checkbox/distribution-list-checkbox.component";
import { FormGroup } from '@angular/forms';
import { DynamicFormArray, selectCheckBoxValues } from '../../model/form.model';
import { FieldNames } from '../../model/form-fields.model';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { CamelCasePipe } from "../../utils/camel-case.pipe";
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-distribution-list-filter-container',
  standalone: true,
  imports: [DistributionListCheckboxComponent, MatChipsModule, MatIconModule, CamelCasePipe, CommonModule],
  templateUrl: './distribution-list-filter-container.component.html',
  styleUrl: './distribution-list-filter-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistributionListFilterContainerComponent implements OnChanges {
  @Input() isReset = false;
  @Input() showJobRoleContainer = false;
  @Input() dynamicFormArray!: DynamicFormArray;
  @Input() form!: FormGroup;
  @Output() selectionChange = new EventEmitter<selectCheckBoxValues>();
  @Output() closeCliked = new EventEmitter<any>();
  selectedNonCertifiableRoles: string[] = [];
  selectedcertifiableRoles: string[] = [];
  formNonCertifiableRoles: any;
  formCertifiableRoles: any;
  changedField: any;
  constructor(readonly cd: ChangeDetectorRef) { }

  handleSelectionChange(event: any) {
    this.updateDisplayFields(event.FieldName, event.Value);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isReset']) {
      this.selectedcertifiableRoles = [];
      this.selectedNonCertifiableRoles = [];
      this.formCertifiableRoles = {};
      this.formNonCertifiableRoles = {};
      this.changedField = null;
      this.cd.markForCheck();
      return;
    }
    if (changes['field']) {
      if (changes['field'].currentValue.fieldName === FieldNames.CertifiableRoles) {
        this.selectedcertifiableRoles = changes['field'].currentValue.selectedValue
      }
      if (changes['field'].currentValue.fieldName === FieldNames.NonCertifiableRoles) {
        this.selectedNonCertifiableRoles = changes['field'].currentValue.selectedValue
      }
    }
    if (changes["dynamicFormArray"]?.currentValue?.FieldsArray) {
      changes["dynamicFormArray"].currentValue.FieldsArray.forEach((filterField: any) => {
        if (filterField.fieldName === FieldNames.CertifiableRoles) {
          this.selectedcertifiableRoles = filterField.selectedValue
        }
        if (filterField.fieldName === FieldNames.NonCertifiableRoles) {
          this.selectedNonCertifiableRoles = filterField.selectedValue
        }
      })
    }
    this.cd.markForCheck();
  }

  removeItem(field: string, value: string) {
    const obj = (field === FieldNames.CertifiableRoles) ? this.formCertifiableRoles : this.formNonCertifiableRoles;

    if (obj) {
      for (const key in obj) {
        const val = obj[key];
        if (val === value) {
          delete obj[key];
        } else if (Array.isArray(val)) {
          obj[key] = val.filter(v => v !== value);
          if ((obj[key] as string[]).length === 0) {
            delete obj[key];
          }
        }
      }
    }
    this.updateDisplayFields(field, obj);
  }

  updateDisplayFields = (FieldName: string, value: any) => {
    if (FieldName === FieldNames.CertifiableRoles) {
      this.selectedcertifiableRoles = this.extractKeysFromObject(value);
      this.formCertifiableRoles = value;
    }
    if (FieldName === FieldNames.NonCertifiableRoles) {
      this.selectedNonCertifiableRoles = this.extractKeysFromObject(value);
      this.formNonCertifiableRoles = value;
    }
    this.changedField = { FieldName: FieldName || '', Value: value }
    this.selectionChange.emit({ FieldName: FieldName || '', Value: value });
    this.cd.markForCheck();
  }
  extractKeysFromObject = (values: any) => {
    return (Object.values(values).flat() as string[]);
  }
  onCloseClicked() {
    this.closeCliked.emit();
  }
}
